<template>
  <div id="serviceNews" v-if="data && data.length">
    <HomeTitle :data="titleData" @moreHandle="moreHandle"></HomeTitle>
    <div class="service-news-container">
      <div
        class="news-box"
        v-for="(item, index) in data"
        :key="index"
        @click="goDetail(item)"
      >
        <p class="title color333">{{ item.title }}</p>
        <p class="from color999">
          <span>{{ moment(item.publishdate).format("YYYY-MM-DD") }}</span>
          <span>{{ item.orgname }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { queryServiceNews } from "@/api/home";
import moment from "moment";
import { complete, locationTo } from "../../utils/url";

export default {
  name: "ServiceNews",
  components: {
    HomeTitle: () => import("./HomeTitle"),
  },
  props: ["title"],
  data() {
    return {
      titleData: {
        title: this.title,
        more: true,
      },
      data: [],
    };
  },
  created() {
    this.getServiceNewsList();
  },
  methods: {
    moment,
    // 获取服务资讯列表
    getServiceNewsList() {
      let params = { pageSize: 4 };
      queryServiceNews(params).then((res) => {
        if (res) {
          if (res.data && res.data.data) {
            this.data = res.data.data || [];
          }
        }
      });
    },
    // 更多点击事件
    moreHandle() {
      this.$router.push("/serviceNews");
    },
    // 咨讯详情
    goDetail(item) {
      // this.$router.push('/serviceNews/detail/'+item.id)
      locationTo(
        complete(`/weixin/weui/gonggao.html?#gonggao/detail/${item.id}`)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
.service-news-container {
  padding: 15px 0;
  .news-box {
    padding: 15px;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    margin-bottom: 15px;
    .title {
      // max-height: 50px;
      // line-height: 25px;
      line-height: 130%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 5px;
      @extend .font16;
    }
    .from {
      height: 20px;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @extend .font13;
      span:first-child {
        position: relative;
        padding-right: 9px;
        margin-right: 8px;
        &:after {
          position: absolute;
          right: 0;
          top: 2px;
          content: "";
          display: block;
          width: 1px;
          height: 12px;
          background: #999;
        }
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
